import { render, staticRenderFns } from "./OwnBrandProduct.vue?vue&type=template&id=70d85701&"
import script from "./OwnBrandProduct.vue?vue&type=script&lang=js&"
export * from "./OwnBrandProduct.vue?vue&type=script&lang=js&"
import style0 from "./OwnBrandProduct.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports